import React from 'react';
import Message from 'components/Message';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import { defineMessages } from 'react-intl';

// Distinct from OpportunitiesEmpty: shown when the opportunities fetch fails (partners-service now
// surfaces real 4xx/5xx instead of ptndash's old 200+empty). Spec 011 US5 / ST-8616.
const messages = defineMessages({
  title: {
    id: 'opportunities.error.header',
    defaultMessage: 'We couldn’t load your opportunities',
  },
  body: {
    id: 'opportunities.error.body',
    defaultMessage: 'Something went wrong on our end. Please refresh the page to try again.',
  },
});

const Error = () => (
  <div className="opportunities__empty">
    <div className="opportunities__checkmark">
      <Isvg src={ICONS.alertTriangle} />
    </div>
    <Message className="mb-s" as="h5" message={messages.title} />
    <Message className="mb-0 text--light text--center" as="p" message={messages.body} />
  </div>
);

export default Error;
